import ChatMessage from './ChatMessage';
import { useState, useRef, useEffect } from 'react';


function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Cookie like "csrftoken=<value>"
        if (cookie.substring(0, name.length + 1) === (name + "=")) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
        }
        }
    }
    return cookieValue;
}

export default function SignupFlow() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    async function getExistingMessages() {
        const csrfToken = getCookie('csrftoken');
            
        // Make the API call with the correct URL format
        const response = await fetch('/api/get_conversation', {
            method: 'POST',
            credentials: 'include',  // Important for cookies
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({}),
        });
        console.log(response);
        
        if (!response.ok) {
            console.error('Server returned status:', response.status);
            const errorText = await response.text();
            console.error('Response text:', errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log(data);
        let messages = [];
        if (data.messages) {
            messages = data.messages.map((message, index) => ({
                id: index + 1,
                message: message.content,
                isUser: message.is_user,
                timestamp: new Date(message.timestamp)
            })).sort((a, b) => a.timestamp - b.timestamp);
        }
        console.log(messages);
        return messages;
    }
    
    // Initialize with empty array
    const [messages, setMessages] = useState([]);

    // Then load messages when component mounts
    useEffect(() => {
        async function loadMessages() {
            try {
                const messagesData = await getExistingMessages();
                setMessages(messagesData);
            } catch (error) {
                console.error('Error loading messages:', error);
            }
        }
        
        loadMessages();
    }, []);

    const chatContainerRef = useRef(null);

    // Scroll to bottom whenever messages change
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [messages]); // Dependency on messages array


    function getChatMessages() {
        return messages.map((message) => (
            <ChatMessage 
                key={message.id} 
                message={message.message} 
                isUser={message.isUser} 
                timestamp={message.timestamp}
            />
        ))
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const formValues = Object.fromEntries(new FormData(e.target));
        
        // Check if message is empty or just whitespace
        if (!formValues.message || formValues.message.trim() === '') {
            return; // Exit the function early if message is empty
        }
        
        setMessages([...messages, {
            id: messages.length + 1,
            message: formValues.message,
            isUser: true,
            timestamp: new Date()
        }]);
        e.target.reset();
        
        // Send message to backend
        try {
            // Get CSRF token directly using your existing function
            const csrfToken = getCookie('csrftoken');
            
            // Make the API call with the correct URL format
            const response = await fetch('/api/submit_message', {
                method: 'POST',
                credentials: 'include',  // Important for cookies
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({ 
                    message: formValues.message 
                }),
            });
            console.log(response);
            
            if (!response.ok) {
                console.error('Server returned status:', response.status);
                const errorText = await response.text();
                console.error('Response text:', errorText);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log(data);
            
            if (data.response) {
                setMessages(prev => [...prev, {
                    id: prev.length + 1,
                    message: data.response,
                    isUser: false,
                    timestamp: new Date()
                }]);
            }
        } catch (error) {
            console.error('Error sending message to server:', error);
        }
    }

    return (
        <div className="signup-flow-container">
            <div className="signup-flow-box">
                <div className="signup-flow-header">
                    <h1 className="signup-flow-title">Congrats on getting started!</h1>
                    <p className="signup-flow-subtitle">Let's work out some details about your chapter and get you started on your journey of telling your story. You're already well on your way!</p>
                </div>
                <div className="signup-flow-chat-container-rounded-border">
                    <div className="signup-flow-chat-container" ref={chatContainerRef}>
                        {getChatMessages()}
                    </div>
                    <form onSubmit={handleSubmit} className="signup-flow-chat-container-input-form">
                        <input 
                            type="text" 
                            className="signup-flow-chat-input-field"     
                            name="message"
                        />
                        <button className="signup-flow-chat-button"></button>                        
                    </form>
                </div>
            </div>
        </div>
    )
}